import { post } from '../../interview-sign-in/utils/request';
import { I18nText, QuestionItem, QuestionnaireState } from './model';

export enum ErrorCode {
    ParseError = -2101007
}

export interface GetQuestionnaireTplPayload {
    questionnaire_token: string;
}
export interface Response {
    company_name: I18nText;
    tenant_id: string;
    biz_modify_time: number;
    biz_create_time: number;
    questionnaire_state: QuestionnaireState;
    questionnaire_template_info: {
        title_info?: I18nText;
        question_list: QuestionItem[];
    };
}

export interface ChoiceQuestionFeedbackInfo {
    option_id: string;
    specific_reason: string;
}
export interface ScorableQuestionFeedbackInfo {
    score: number;
    specific_reason: string;
}

export interface SingleChoiceQuestionFeedback {
    question_id: string;
    answer: ChoiceQuestionFeedbackInfo;
}
export interface MultipleChoiceQuestionFeedback {
    question_id: string;
    answer: ChoiceQuestionFeedbackInfo[];
}
export interface ScorableQuestionFeedback {
    question_id: string;
    answer: ScorableQuestionFeedbackInfo;
}
export interface OpenQuestionFeedback {
    question_id: string;
    answer: string;
}

export interface QuestoinnaireSubmitRequset {
    questionnaire_token: string;
    single_choice_question_feedbacks: SingleChoiceQuestionFeedback[];
    multiple_choice_question_feedbacks: MultipleChoiceQuestionFeedback[];
    scorable_question_feedbacks: ScorableQuestionFeedback[];
    open_question_feedbacks: OpenQuestionFeedback[];
    template_id?: string;
    hide_question_ids?: string[];
}

export interface QuestoinnaireSubmitResponse {
    questionnaire_state: QuestionnaireState;
    questionnaire_modify_tiome: number;
}

export const submitRequest = (
    payload: QuestoinnaireSubmitRequset
): Promise<QuestoinnaireSubmitResponse> => {
    return post<QuestoinnaireSubmitResponse>(`/atsx/public_api/questionnaire/submit/`, payload, {
        notifyHttpError: true,
        notifyBizError: true,
        headers: {
            // 'ax-psm-host-map': '{"people.atsx.questionnaire_boe":"10.90.204.99:8094"}'
        }
    }).then(({ success, data, code, message }) => {
        if (!success || !data) {
            return Promise.reject({ code, message });
        }
        return data;
    });
};
